import React, { FC, ReactElement } from 'react';

import { Redirect, useLocation } from 'react-router-dom';

import { AppHeader } from '../index';

import { useUserData } from 'context';
import { ROLE_NAME } from 'enums';
import { IRoute, PATHS } from 'types';
import { RouteContent } from 'views/components/RouteContent/RouteContent';
import { AccessDenied } from 'views/pages/AccessDenied';
import { FrozenOrganization } from 'views/pages/FrozenOrganization';

const ProtectedRoute: FC<IRoute> = ({ component, pageTitle }): ReactElement => {
  const { user, billingStatus, forbiddenAccess, frozenOrganization } = useUserData();
  const location = useLocation();
  const isAdmin = user?.role.name === ROLE_NAME.ADMIN;
  const isRecoveryRoute =
    location.pathname === PATHS.MANAGE_ORGANIZATION ||
    location.pathname === PATHS.MANAGE_ORGANIZATION_SUBSCRIPTION_MANAGEMENT ||
    location.pathname === PATHS.MANAGE_ORGANIZATION_USER_MANAGEMENT;
  const isOrganizationFrozen =
    Boolean(frozenOrganization) || billingStatus?.accessStatus === 'FROZEN';
  const canUseRecoveryRoute = isAdmin && isRecoveryRoute;

  let routeContent: ReactElement;

  if (isOrganizationFrozen && !canUseRecoveryRoute) {
    routeContent = <FrozenOrganization />;
  } else if (forbiddenAccess) {
    routeContent = <AccessDenied />;
  } else {
    routeContent = <RouteContent component={component} pageTitle={pageTitle} />;
  }

  return user ? (
    <>
      <AppHeader />
      {routeContent}
    </>
  ) : (
    <Redirect to={PATHS.LOGIN} />
  );
};

export { ProtectedRoute };
